import { render, staticRenderFns } from "./InsumosCompuestosForm.vue?vue&type=template&id=4d500e5c"
import script from "./InsumosCompuestosForm.vue?vue&type=script&lang=js"
export * from "./InsumosCompuestosForm.vue?vue&type=script&lang=js"
import style0 from "./InsumosCompuestosForm.vue?vue&type=style&index=0&id=4d500e5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports